<template>
  <div>
    <Master :pageTitle="pageTitle">
      <template #button>
        <NormalButton
          :text="buttonName"
          height="32px"
          width="136px"
          class="text-right"
          @click="dialogInfo.register = true"
        />
        <MasterSuggestedReceivingLocationDialog
          v-model="dialogInfo.register"
          @success="registerSuccess()"
        />
      </template>
      <template #list>
        <div class="suggestedReceivingLocationTable">
          <v-data-table
            :headers="tableHeaders"
            :items="getSuggestedReceivingLocationListFromState()"
            :item-key="itemKey"
            :items-per-page="-1"
            hide-default-footer
            :no-data-text="$t('common.common_not-register')"
            class="rounded-lg"
          >
            <template #[`item.location`]="{ item }">
              <div class="font-weight-bold">{{ item.location || '-' }}</div>
            </template>
            <template #[`item.address`]="{ item }">
              <div
                v-if="
                  getPostalCode(item.postalCode, item.addressCountryId) ||
                  getRegionName(item.addressCountryId, item.regionId) ||
                  item.address1 ||
                  item.address2
                "
                class="my-2"
              >
                <v-row
                  v-if="getPostalCode(item.postalCode, item.addressCountryId)"
                  no-gutters
                >
                  {{
                    '〒' + getPostalCode(item.postalCode, item.addressCountryId)
                  }}
                </v-row>
                <v-row no-gutters>{{
                  (getRegionName(item.addressCountryId, item.regionId) || '') +
                  (item.address1 || '')
                }}</v-row>
                <v-row no-gutters>{{ item.address2 }}</v-row>
              </div>
              <div v-else class="my-2">{{ '-' }}</div>
            </template>
            <template #[`item.phoneNumber`]="{ item }">
              <v-row no-gutters class="my-2">
                <div
                  v-if="
                    getPhoneNumber(item.phoneNumber, item.phoneNumberCountryId)
                  "
                >
                  {{
                    'TEL:' +
                    getPhoneNumber(item.phoneNumber, item.phoneNumberCountryId)
                  }}
                </div>
                <div v-else>{{ '-' }}</div>
              </v-row>
            </template>
            <template #[`item.sortNumber`]="{ item }">
              <div class="text-center">
                {{ item.sortNumber || '-' }}
              </div>
            </template>
            <template #[`item.editAndDelete`]="{ item }">
              <v-row>
                <v-col cols="6" class="text-center px-0">
                  <WhiteButton
                    text="common.common_edit"
                    height="32px"
                    width="48px"
                    @click.native="edit(item)"
                  />
                </v-col>
                <v-col cols="6" class="text-center px-0">
                  <WhiteButton
                    text="common.input_delete"
                    height="32px"
                    width="48px"
                    @click.native="deleteInfo(item)"
                  />
                </v-col>
              </v-row>
            </template>
          </v-data-table>
        </div>
      </template>
    </Master>
    <MasterSuggestedReceivingLocationDialog
      v-model="dialogInfo.edit"
      :suggestedReceivingLocationData="suggestedReceivingLocationData"
      :editMode="true"
      @success="editSuccess()"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { commonUtil, countryUtil, countryCallingCodeUtil } from '@/util'
import headers from './headers'
import { Master } from '@/components/layouts'
import { MasterSuggestedReceivingLocationDialog } from '@/components/layouts/Dialogs'
import { NormalButton, WhiteButton } from '@/components/items'
export default {
  components: {
    Master,
    MasterSuggestedReceivingLocationDialog,
    NormalButton,
    WhiteButton
  },
  data: () => {
    return {
      pageTitle: 'storage.storage_suggested-receiving-location-management',
      buttonName: 'storage.storage_suggested-receiving-location-register',
      suggestedReceivingLocationData: {},
      dialogInfo: {
        register: false,
        edit: false
      },
      headers: headers.headers,
      itemKey: 'suggestedReceivingLocationId',
      editMode: false
    }
  },
  created() {
    this.init()
  },
  computed: {
    tableHeaders() {
      const tmp = this.headers.map((ele) => {
        const params = { ...ele }
        params.text = this.$t(ele.text)
        return params
      })
      return tmp
    }
  },
  methods: {
    ...mapActions('Supplier', [
      'getSuggestedReceivingLocationListFromApi',
      'deleteSuggestedReceivingLocation'
    ]),
    ...mapGetters('Supplier', ['getSuggestedReceivingLocationListFromState']),
    async init() {
      await this.getSuggestedReceivingLocationListFromApi()
    },
    getPostalCode(postalCode, countryId) {
      return commonUtil.formatPostalCode(postalCode, countryId)
    },
    getPhoneNumber(phone, callingCode) {
      return countryCallingCodeUtil.formatPhoneNumber(phone, callingCode)
    },
    edit(suggestedReceivingLocation) {
      this.suggestedReceivingLocationData = { ...suggestedReceivingLocation }
      this.dialogInfo.edit = true
    },
    registerSuccess() {
      this.init()
      this.dialogInfo.register = false
    },
    editSuccess() {
      this.init()
      this.dialogInfo.edit = false
    },
    async deleteInfo(suggestedReceivingLocation) {
      const isConfirmed = confirm(
        this.$t(
          'master.suggested-receiving-location_confirm-to-delete-suggested-receiving-location'
        )
      )
      if (!isConfirmed) {
        return
      }
      suggestedReceivingLocation.id =
        suggestedReceivingLocation.suggestedReceivingLocationId
      const success = await this.deleteSuggestedReceivingLocation(
        suggestedReceivingLocation
      )
      this.init()
      alert(this.$t('common.common_delete-comp'))
    },
    getRegionName(countryId, regionId) {
      return countryUtil.getRegionInfo(countryId, regionId).label
    }
  }
}
</script>
<style scoped lang="scss">
.suggestedReceivingLocationTable {
  ::v-deep .v-data-table th {
    background-color: rgba(151, 198, 234, 0.1);
    border-collapse: collapse;
    text-align: center !important;
    padding: 10px 0px !important;
    white-space: pre-wrap;
    border: 1px solid #d8d8d8;
    border-right: 0;
  }
  ::v-deep .v-data-table th:last-child {
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table td {
    background-color: #f6f6f6;
    border-collapse: collapse;
    border: 1px solid #d8d8d8;
    border-top: 0;
    border-right: 0;
    border-spacing: 0;
    margin: -1px;
  }
  ::v-deep .v-data-table td:last-child {
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table tr:nth-child(odd) td {
    background-color: rgba(213, 213, 213, 0.1);
    border-collapse: collapse;
    border: 1px solid #d8d8d8;
    border-top: 0;
    border-right: 0;
    border-spacing: 0;
    margin: -1px;
  }
  ::v-deep .v-data-table tr:nth-child(odd) td:last-child {
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table tr:hover td {
    background-color: #eee;
  }
  ::v-deep .v-data-table thead th:first-child {
    border-radius: 10px 0 0 0;
  }
  ::v-deep .v-data-table thead th:last-child {
    border-radius: 0 10px 0 0;
  }
  ::v-deep .v-data-table tr:last-child td:first-child {
    border-radius: 0 0 0 10px;
  }
  ::v-deep .v-data-table tr:last-child td:last-child {
    border-radius: 0 0 10px 0;
  }
}
</style>
